module.exports = __webpack_public_path__ + "img/14.837f486c.png";